import { makeStyles } from '@mui/styles'

const styles = makeStyles((_) => ({
  leftSide: {
    padding: '10px 0',
    display: 'flex',
    gap: '1rem',
    alignItems: 'center',
  },
  rightSide: {
    padding: '10px 0',
    display: 'flex',
    gap: '1rem',
    alignItems: 'center',
    marginTop: 5,
  },
  leftSideButton: {
    padding: 0,
    minWidth: 2,
    alignSelf: 'center',
  },

  filterButton: {
    minWidth: 2,
    padding: '1px 11px',
    borderColor: '#bbb',
    marginTop: 9,
    fontSize: '1.3rem',
    alignSelf: 'center',
  },
  txtField: {
    width: '17vw',
    minWidth: 273,
  },
}))
export default styles
